import { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import Spinner from "../spinner/Spinner";
import { useLocation, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import formatDate from "../../components/utils/DateFormatter";

const SecurityQuestionDetails = () => {
    const [securityQuestion, setSecurityQuestion] = useState(null);
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    // Get the security question data from the location state
    const { data } = location.state || {};

    useEffect(() => {
        if (data) {
            setSecurityQuestion(data);
            setLoading(false);
        } else {
            toast.error("Security question data is missing.");
            setLoading(false);
        }
    }, [data]);

    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    {/* Breadcrumb */}
                    <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
                        <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                            <ol className="list-none p-0 inline-flex mb-2">
                                <li className="flex items-center">
                                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                        Security
                                    </p>
                                    <ChevronRightIcon />
                                </li>
                                <li className="flex items-center">
                                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                        Questions
                                    </p>
                                    <ChevronRightIcon />
                                </li>
                                <li className="flex items-center">
                                    <p className="text-orange1">Details</p>
                                </li>
                            </ol>
                        </nav>
                    </section>

                    {/* Back Button - Exactly like OrderById */}
                    <div className="flex justify-end mb-4">
                        <Link
                            to="/admin/security/question/list"
                            className="w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                        >
                            <span className="flex justify-center sm:justify-start mx-2">
                                Go Back to List
                            </span>
                        </Link>
                    </div>

                    {loading ? (
                        <Spinner loading={loading} />
                    ) : securityQuestion ? (
                        <div className="p-2 w-full mt-4">
                            {/* Main Details Table - Same structure as OrderById */}
                            <div className="flex items-center border-dash p-1">
                                <div className="relative shadow-md sm:rounded-lg w-full overflow-x-auto">
                                    <table className="min-w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 px-2 py-5">
                                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                            <tr>
                                                <th className="px-6 py-3 border border-darkGreen3 bg-darkGreen3 text-lGrey dark:border-gray-700">
                                                    Details
                                                </th>
                                                <th className="px-6 py-3 border border-gray-300 bg-darkGreen3 text-lGrey dark:border-gray-700">
                                                    Value
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                <th scope="row" className="px-6 py-4 border border-darkGreen3">
                                                    Question Text
                                                </th>
                                                <td className="px-6 py-4 border border-darkGreen3">
                                                    {securityQuestion.question_text || "NOT AVAILABLE"}
                                                </td>
                                            </tr>
                                            <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                <th scope="row" className="px-6 py-4 border border-darkGreen3">
                                                    Description
                                                </th>
                                                <td className="px-6 py-4 border border-darkGreen3">
                                                    {securityQuestion.description || "No description provided"}
                                                </td>
                                            </tr>
                                            <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                <th scope="row" className="px-6 py-4 border border-darkGreen3">
                                                    Status
                                                </th>
                                                <td className="px-6 py-4 border border-darkGreen3">
                                                    <span className={`px-3 py-1 rounded-full text-sm ${securityQuestion.is_active
                                                        ? "bg-green-100 text-green-800"
                                                        : "bg-red-100 text-red-800"
                                                        }`}>
                                                        {securityQuestion.is_active ? "ACTIVE" : "INACTIVE"}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                <th scope="row" className="px-6 py-4 border border-darkGreen3">
                                                    Created Date
                                                </th>
                                                <td className="px-6 py-4 border border-darkGreen3">
                                                    {securityQuestion.created_at ? formatDate(securityQuestion.created_at) : "NOT AVAILABLE"}
                                                </td>
                                            </tr>
                                            <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                                                <th scope="row" className="px-6 py-4 border border-darkGreen3">
                                                    Updated Date
                                                </th>
                                                <td className="px-6 py-4 border border-darkGreen3">
                                                    {securityQuestion.updated_at ? formatDate(securityQuestion.updated_at) : "NOT AVAILABLE"}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    ) : (
                        // Error state - similar to OrderById if no data
                        <div className="text-center py-8">
                            <p className="text-gray-500">No security question data available.</p>
                        </div>
                    )}
                </div>
            </MainLayouts>
        </div>
    );
};

export default SecurityQuestionDetails;